import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MoonIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M9.0957 2.42871C9.4487 2.32178 9.83196 2.4179 10.0928 2.67871C10.3536 2.93954 10.4497 3.32279 10.3428 3.67578C10.1202 4.41014 10 5.19011 10 6C10 10.4183 13.5817 14 18 14C18.8101 14 19.5902 13.8807 20.3242 13.6582C20.6771 13.5512 21.0604 13.6466 21.3213 13.9072C21.5821 14.1681 21.6783 14.5522 21.5713 14.9053C20.3268 19.0105 16.5138 22 12 22C6.4772 22 2.00001 17.5229 2 12C2.00006 7.48601 4.99037 3.67301 9.0957 2.42871ZM8.0459 5.04492C5.62921 6.42189 4.00005 9.02119 4 12C4.00001 16.4182 7.58169 20 12 20C14.9793 20 17.5782 18.3702 18.9551 15.9531C18.6405 15.9829 18.322 16 18 16C12.4772 16 8.00001 11.5228 8 6C8 5.67799 8.01606 5.35944 8.0459 5.04492Z'
        fill={color}
      />
    </svg>
  )
})
